import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IMerchantAccount } from '../../../../interfaces/IMerchantAccount';
import { OrderListHeaders } from '../../../orders/OrderList/OrderListViewHeaders';
import { Loading } from '../../../util/ListLoading';
import UserList from '../UserList';

import { userManagementColumns } from "../UserList/UserList.columns";


export interface IUserManagementContent {
    users: IMerchantAccount[];
    isLoading: boolean;
}

const useStyles = makeStyles({
    columnsHeader: {
      display: 'flex',
      alignItems: 'center',
      margin: "0 3rem",

  
      '& > div': {
        width: '25%',
  
        '& > span': {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '0.9rem',
          lineHeight: '1.25rem',
          display: 'flex',
          justifyContent: 'start',
          color: '#8d98b7',
          textAlign: "left"
        }
      }
    },
  });

const UserManagementContent = ({
    users,
    isLoading
}: IUserManagementContent) => {

    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div data-component-name="UserManagementContainer">
            <div key={`columnHeaders-userManagement`} className={classes.columnsHeader}>
                {
                    userManagementColumns.map((column) => (
                        <OrderListHeaders textAlign="left" {...column} key={`col-${column.key}-${column.label}`} />
                    ))
                }
            </div>
            {
            isLoading ? 
                <Loading /> :
                <UserList
                    users={users || []}
                    columns={userManagementColumns}
                    emptyListTitle={t("user_management.container.emptyList")}
                    emptyListInfo={t("user_management.container.emptyListInfo")}
                />
            }
        </div>
    )
}

export default UserManagementContent;